import { addDays, format } from 'date-fns'
import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedValue } from '@utils/debounce'

import { FilterQueryProps } from '@model/FilterFields'

const DATE_FORMAT = 'MM/dd/yyyy'

const initialSearch: FilterQueryProps = {
  ca_search_TextSearch: undefined,

  ca_search_DateFrom: format(addDays(new Date(), -7), DATE_FORMAT),
  ca_search_DateTo: format(addDays(new Date(), 7), DATE_FORMAT),
}

export const useStockDividendsSearch = () => {
  const { t } = useTranslation()
  const [search, setSearch] = useState<FilterQueryProps>(initialSearch)

  const [searchTerm, setSearchTerm] = useState<string | null>(null)
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 500)

  const clearSearch = useCallback(() => {
    setSearch(initialSearch)
  }, [])

  const sortOptions = useMemo(
    () => [
      { id: 'Date', name: t('Date') },
      { id: null, name: t('Stock Dividends.Name') },
      { id: null, name: t('Stock Dividends.Symbol') },
      { id: null, name: t('Stock Dividends.Gross Dividend Amount') },
    ],
    [t]
  )

  return {
    search,
    setSearch,
    clearSearch,
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm,
    sortOptions,
    placeholder: t('Search name, symbol'),
  }
}
